import React from 'react';
import { Box, Stack } from '@mui/material';

export interface DataToolbarProps {
  children: React.ReactNode;
  end?: React.ReactNode;
}

/** Sticky filter/search row for tables and lists. */
const DataToolbar: React.FC<DataToolbarProps> = ({ children, end }) => (
  <Box
    sx={{
      mb: 2,
      p: 1.5,
      borderRadius: 2,
      border: '1px solid',
      borderColor: 'divider',
      bgcolor: 'background.paper',
      display: 'flex',
      flexDirection: { xs: 'column', md: 'row' },
      alignItems: { xs: 'stretch', md: 'center' },
      justifyContent: 'space-between',
      gap: 1.5,
      position: 'sticky',
      top: { xs: 56, md: 0 },
      zIndex: 2,
      backdropFilter: 'blur(8px)',
    }}
  >
    <Stack direction="row" spacing={1} flexWrap="wrap" useFlexGap sx={{ alignItems: 'center', flex: 1 }}>
      {children}
    </Stack>
    {end && (
      <Stack direction="row" spacing={1} flexWrap="wrap" useFlexGap sx={{ alignItems: 'center' }}>
        {end}
      </Stack>
    )}
  </Box>
);

export default DataToolbar;
